import React from "react";
import { Switch, Route } from "react-router-dom";
import { Search } from "../Shared";
import Job from "./Job/index";
import JobList from "./JobList";
import { EditJob } from "../Employers";

const excludedViews = ["/employers/post-job"];

const Jobs = ({ location, history, job, user, jobs, match, notify }) => (
  <div id="Jobs" style={{ minHeight: "100vh" }}>
    <div style={{ background: "#fff" }}>
      {!excludedViews.includes(location.pathname) && (
        <Search history={history} />
      )}
      <Switch>
        <Route exact path="/jobs" render={(props) => <JobList {...props} />} />
        <Route
          exact
          path="/jobs/:slug"
          render={(props) => (
            <Job
              {...props}
              user={user}
              job={job}
              sidebarJobs={jobs}
              slug={match.params.slug}
              notify={notify}
            />
          )}
        />
        <Route
          exact
          path="/jobs/:slug/edit"
          render={(props) => (
            <EditJob
              {...props}
              user={user}
              slug={match.params.slug}
              notify={notify}
            />
          )}
        />
      </Switch>
    </div>
  </div>
);

export { Jobs, Job, JobList };
